import { render } from "./instruction-lists.vue?vue&type=template&id=3d6721c6&scoped=true"
import script from "./instruction-lists.vue?vue&type=script&lang=js"
export * from "./instruction-lists.vue?vue&type=script&lang=js"

import "./instruction-lists.vue?vue&type=style&index=0&id=3d6721c6&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6721c6"]])

export default __exports__